<script setup>
import { Icon } from '@iconify/vue';
</script>

<template>
  <div class="dropdown relative">
    <button class="dropdown-button flex items-center gap-2 font-bold p-2">
      <slot />
      <Icon icon="ri:arrow-drop-down-line" />
    </button>

    <div class="dropdown-menu">
      <slot name="items" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dropdown {
  &-menu {
    display: none;
    position: absolute;
    top: 0;
    padding-top: 2.5rem;
    background-color: var(--color-white);
    color: var(--color-green-pine);
    min-width: 200px;
    width: 100%;
    right: 0;
    z-index: 5;
    border: 2px var(--color-green-dark) solid;

    & > :deep(a),
    & > :deep(button) {
      display: flex;
      padding: calc(var(--spacing) * 2);
      text-decoration: none;
      align-items: center;
      gap: calc(var(--spacing) * 2);

      &:hover {
        background-color: var(--color-yellow);
        color: var(--color-green-pine);
      }
    }
  }

  &:hover,
  &:focus-within {
    .dropdown-button {
      position: relative;
      background-color: transparent;
      color: var(--color-green-dark);
      z-index: 10;
    }
  
    .dropdown-menu {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>